import _ from 'lodash';

function runOnInit(cb, params) {
    if (cb) {
        cb(params);
    }
}

// HOC that wraps a view-store class to attach onInit/onViewUpdate event
// listeners when there is an authenticated application context.
//
// The babel-6 idiom `Store.apply(this, args)` to mutate `this` from a
// function-style wrapper sharing the Store's prototype does not work under
// babel 7's class transform — `class X` is constructed via Reflect.construct,
// which ignores the outer `this`. Use normal subclassing instead.
export default function applicationContext(Store) {
    return class Injected extends Store {
        constructor(...args) {
            super(...args);
            const rootStore = _.first(args);
            if (!rootStore) return;
            if (rootStore.application) {
                runOnInit(this.onInit, { initialLoad: true });
            }
            this.addEvent('onInit', () => {
                runOnInit(this.onInit, { initialLoad: false });
            });
            this.addEvent('onViewUpdate', () => {
                runOnInit(this.onViewUpdate);
            });
        }
    };
}
